﻿var BD = typeof BD === "object" ? BD : {};

// Constants
var CONST_E6 = 82;		// Intake Air Tempature
var CALC_CELSIUS = ((5 / 9) * (CONST_E6 - 32)).toFixed(1);		// Intake Air Tempature
var CONST_E16 = 95;		// Engine Volumetric Efficiency
var CONST_E17 = 0.5;	// Air Filter Pressure Loss
var CONST_E30 = 65; 	// Compressor Efficiency

BD.Calculator = {};
BD.Calculator.Compute = function () {
	// User entered fields
	var USER_E8 = document.getElementById("USER_E8"); 	// Altitude feet above sea level
	var USER_E13 = document.getElementById("USER_E13"); // Engine Displacement
	var USER_E19 = document.getElementById("USER_E19"); // Engine Speed
	var USER_E20 = document.getElementById("USER_E20"); // Boost Pressure (Gauge)
	var USER_E24 = document.getElementById("USER_E24"); // Intercooler Effectiveness
	var USER_E25 = document.getElementById("USER_E25"); // Intercooler Pressure Loss

	// Calculated fields
	var CALC_E9 = document.getElementById("CALC_E9"); 	// PSI barometric pressure
	var CALC_E14 = document.getElementById("CALC_E14"); // Cubic Inch
	var CALC_E33 = document.getElementById("CALC_E33"); // Flow Rate Required
	var CALC_E34 = document.getElementById("CALC_E34"); // Air Flow Rate Required

	var CALC_C36 = document.getElementById("CALC_C36"); // Engine HP Estimated
	var CALC_E36 = document.getElementById("CALC_E36"); // Engine HP Estimated

	var CALC_C38 = document.getElementById("CALC_C38"); // Compressor Wheel Size Estimated
	var CALC_E38 = document.getElementById("CALC_E38"); // Compressor Wheel Size Estimated

	var CALC_F47 = document.getElementById("CALC_F47"); // Compressor Pressure Ratio
	var CALC_F48 = document.getElementById("CALC_F48"); // Comp Outlet Temp
	var CALC_F49 = document.getElementById("CALC_F49"); // Intake Manifold Temp
	var CALC_F50 = document.getElementById("CALC_F50"); // Intake Manifold Density

	var CALC_F53 = document.getElementById("CALC_F53"); // Compressor Pressure Ratio
	var CALC_F54 = document.getElementById("CALC_F54"); // Comp Outlet Temp
	var CALC_F55 = document.getElementById("CALC_F55"); // Intake Manifold Temp
	var CALC_F56 = document.getElementById("CALC_F56"); // Intake Manifold Density
	var CALC_F57 = document.getElementById("CALC_F57"); // Flow Rate
	var CALC_F58 = document.getElementById("CALC_F58"); // Air Flow Rate


	// Result calculations
	var RESULT_E9 = ((101325 * Math.pow((1 - (2.25577 * (Math.pow(10, -5))) * (USER_E8.value / 3.28083)), 5.25588)) * 0.0001450377);
	CALC_E9.innerHTML = isFinite(RESULT_E9) ? RESULT_E9.toFixed(2) : 0.00;
	CALC_E9_NUM = Number(CALC_E9.innerHTML);

	var RESULT_E14 = (USER_E13.value * 61.02374);
	CALC_E14.innerHTML = isFinite(RESULT_E14) ? RESULT_E14.toFixed(2) : 0.00;
	CALC_E14_NUM = Number(CALC_E14.innerHTML);

	var RESULT_F47 = (Number(USER_E20.value) + CALC_E9_NUM - CONST_E17 + Number(USER_E25.value)) / (CALC_E9_NUM - CONST_E17);
	CALC_F47.innerHTML = isFinite(RESULT_F47) ? RESULT_F47.toFixed(8) : 0.00;
	CALC_F47_NUM = Number(CALC_F47.innerHTML);

	var RESULT_F48 = (((460 + CONST_E6) * Math.pow(CALC_F47_NUM, ((1.395 - 1) / 1.395)) - 460 - CONST_E6) / (CONST_E30 * 0.01) + CONST_E6);
	CALC_F48.innerHTML = isFinite(RESULT_F48) ? RESULT_F48.toFixed(8) : 0.00;
	CALC_F48_NUM = Number(CALC_F48.innerHTML);

	var RESULT_F49 = ((CALC_F48_NUM - (USER_E24.value * 0.01) * (CALC_F48_NUM - CONST_E6)));
	CALC_F49.innerHTML = isFinite(RESULT_F49) ? RESULT_F49.toFixed(8) : 0.00;
	CALC_F49_NUM = Number(CALC_F49.innerHTML);

	var RESULT_F50 = (CALC_E9_NUM + Number(USER_E20.value)) / 639.6 / (460 + CALC_F49_NUM);
	CALC_F50.innerHTML = isFinite(RESULT_F50) ? RESULT_F50.toFixed(8) : 0.00;
	CALC_F50_NUM = Number(CALC_F50.innerHTML);

	var RESULT_E34 = ((CALC_F50_NUM * (CONST_E16 * 0.01) * Number(USER_E19.value) * CALC_E14_NUM) / 2);
	CALC_E34.innerHTML = isFinite(RESULT_E34) ? RESULT_E34.toFixed(2) : 0.00;
	CALC_E34_NUM = Number(CALC_E34.innerHTML);

	var RESULT_E33 = (((CALC_E34_NUM / 2.2) * (1 / 1.1614)) * 35.314);
	CALC_E33.innerHTML = isFinite(RESULT_E33) ? RESULT_E33.toFixed(0) : 0.00;

	var RESULT_E36 = (((60 * CALC_E34_NUM) / (22)) / 0.38);
	CALC_E36.innerHTML = isFinite(RESULT_E36) ? RESULT_E36.toFixed(0) : 0.00;
	CALC_E36_NUM = Number(CALC_E36.innerHTML);

	var RESULT_C36 = (CALC_E36_NUM * 0.75);
	CALC_C36.innerHTML = isFinite(RESULT_C36) ? RESULT_C36.toFixed(0) : 0.00;

	var RESULT_F53 = (Number(USER_E20.value) + 14.7 - CONST_E17 + Number(USER_E25.value)) / (14.7 - CONST_E17);
	CALC_F53.innerHTML = isFinite(RESULT_F53) ? RESULT_F53.toFixed(8) : 0.00;
	CALC_F53_NUM = Number(CALC_F53.innerHTML);

	var RESULT_F54 = (((460 + CONST_E6) * Math.pow(CALC_F53_NUM, ((1.395 - 1) / 1.395)) - 460 - CONST_E6) / (CONST_E30 * 0.01) + CONST_E6);
	CALC_F54.innerHTML = isFinite(RESULT_F54) ? RESULT_F54.toFixed(8) : 0.00;
	CALC_F54_NUM = Number(CALC_F54.innerHTML);

	var RESULT_F55 = ((CALC_F54_NUM - (USER_E24.value * 0.01) * (CALC_F54_NUM - CONST_E6)));
	CALC_F55.innerHTML = isFinite(RESULT_F55) ? RESULT_F55.toFixed(8) : 0.00;
	CALC_F55_NUM = Number(CALC_F55.innerHTML);

	var RESULT_F56 = (14.7 + Number(USER_E20.value)) / 639.6 / (460 + CALC_F55_NUM);
	CALC_F56.innerHTML = isFinite(RESULT_F56) ? RESULT_F56.toFixed(8) : 0.00;
	CALC_F56_NUM = Number(CALC_F56.innerHTML);

	var RESULT_F57 = ((CALC_F56_NUM * (CONST_E16 * 0.01) * USER_E19.value * CALC_E14_NUM) / 2);
	CALC_F57.innerHTML = isFinite(RESULT_F57) ? RESULT_F57.toFixed(8) : 0.00;
	CALC_F57_NUM = Number(CALC_F57.innerHTML);

	var RESULT_F58 = (((CALC_F57_NUM / 2.2) * (1 / 1.1614)) * 35.314);
	CALC_F58.innerHTML = isFinite(RESULT_F58) ? RESULT_F58.toFixed(8) : 0.00;
	CALC_F58_NUM = Number(CALC_F58.innerHTML);

	var RESULT_C38 = (((Math.sqrt(CALC_F58_NUM)) * 6) / Math.PI);
	CALC_C38.innerHTML = isFinite(RESULT_C38) ? RESULT_C38.toFixed(1) : 0.00;
	CALC_C38_NUM = Number(CALC_C38.innerHTML);

	var RESULT_E38 = (CALC_C38_NUM * 1.1);
	CALC_E38.innerHTML = isFinite(RESULT_E38) ? RESULT_E38.toFixed(1) : 0.00;
};
BD.Calculator.Reset = function () {
	document.getElementById("USER_E8").focus();
};
BD.Calculator.Setup = function () {
	// Populate Constants
	document.getElementById("CONST_E6").innerHTML = CONST_E6;
	document.getElementById("CALC_CELSIUS").innerHTML = CALC_CELSIUS;
	document.getElementById("CONST_E16").innerHTML = CONST_E16;
	document.getElementById("CONST_E17").innerHTML = CONST_E17;
	document.getElementById("CONST_E30").innerHTML = CONST_E30;

	document.getElementById("USER_E8").value = 500;		// Altitude feet above sea level
	document.getElementById("USER_E13").value = 6.7;	// Engine Displacement
	document.getElementById("USER_E19").value = 4000;	// Engine Speed
	document.getElementById("USER_E20").value = 40;		// Boost Pressure (Gauge)
	document.getElementById("USER_E24").value = 85;		// Intercooler Effectiveness
	document.getElementById("USER_E25").value = 4;		// Intercooler Pressure Loss

	document.getElementById("USER_E8").focus();
};


// DOMContentLoaded
document.addEventListener("DOMContentLoaded", function () {
	BD.Calculator.Setup(); BD.Calculator.Compute();

	$(document.body).tooltip({
		selector: '[data-toggle=tooltip]',
		container: 'body'
	});
}, false);
